// Shared whole-day arithmetic for YYYY-MM-DD calendar strings. Inputs are
// parsed as UTC midnight and compared via Date.UTC, which avoids DST
// off-by-ones and treats contract dates as calendar-day values rather than
// instants. Malformed input yields NaN, so callers fall through to their
// default branch instead of silently lexicographically comparing garbage.

export function isoDayUTC(iso: string): number {
  const d = new Date(`${iso}T00:00:00Z`);
  return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
}

export function daysBetween(fromIso: string, toIso: string): number {
  return Math.round((isoDayUTC(toIso) - isoDayUTC(fromIso)) / 86_400_000);
}
